
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(1007),
  playerId: Number,
  reason: Number.withConstraint(x => x >= 0 && x <= 1000),
}).And(Partial({
  currency1: Number,
  currency2: Number,
  wood: Number,
  stone: Number,
  coal: Number,
  oil: Number,
  glass: Number,
  aquamarine: Number,
  iron: Number,
  capitalCoins: Number,
  allianceId: Number.withConstraint(x => x >= -1),
  otherAllianceId: Number.withConstraint(x => x >= -1),
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(1007),
  playerId: Number,
  reason: Number.withConstraint(x => x >= 0 && x <= 1000),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
}).And(Partial({
  currency1: Number,
  currency2: Number,
  wood: Number,
  stone: Number,
  coal: Number,
  oil: Number,
  glass: Number,
  aquamarine: Number,
  iron: Number,
  capitalCoins: Number,
  allianceId: Number.withConstraint(x => x >= -1),
  otherAllianceId: Number.withConstraint(x => x >= -1),
  networkId: Number.withConstraint(x => x >= 0 && x <= 1000),
  instanceId: Number.withConstraint(x => x >= 0 && x <= 1000),
  zoneId: Number.withConstraint(x => x >= -1 && x <= 1000),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 1007;
  